import { createFileRoute, Outlet, useMatch } from '@tanstack/react-router';
import { ResourceHub } from '../../components/resources/ResourceHub';
import { useSEO, useBreadcrumbSchema, PageSEO } from '../../lib/seo';

export const Route = createFileRoute('/resources/case-studies')({
  component: CaseStudiesPage,
});

function CaseStudiesPage() {
  const slugMatch = useMatch({ from: '/resources/case-studies/$slug', shouldThrow: false });

  useSEO(PageSEO.caseStudies);
  useBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Case Studies', url: '/resources/case-studies' },
  ]);

  if (slugMatch) {
    return <Outlet />;
  }

  return <ResourceHub defaultType="case-study" />;
}
